// import React from "react";

// const percentagesizeStyles = {
//   sm: "!text-[11px]",
//   md: "!text-[12px]",
//   lg: "!text-[13px]",
//   xl: "!text-[14px]",
// };
// const sizeStyles = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const sizeValueStyles = {
//   sm: "text-[34px]",
//   md: "text-[30px]",
//   lg: "text-[38px]",
//   xl: "text-[40px]",
// };

// const InfoCardNew = ({ title, value, backValue, size = "md" }) => {
//   //get percentage change
//   const percentageChange = ((value - backValue) / backValue) * 100;
//   //get percentage change color
//   const percentageChangeColor =
//     percentageChange > 0
//       ? "bg-success-500 text-white"
//       : "bg-danger-500 text-white";
//   return (
//     <div className="bg-red">
//       <div className="p-3 bg-gradient-to-b from-gray-200 to-white rounded-2xl shadow">
//         <div className=" w-full h-full flex flex-col gap-4">
//           <div>
//             <div className={`${sizeStyles[size]} max-w-[120px] line-clamp-2`}>
//               {title}
//             </div>
//           </div>
//           <div className="flex-1 gap-2 flex justify-center items-center">
//             <div className={`${sizeValueStyles[size]} font-semibold`}>
//               {value}
//             </div>
//             <div
//               className={`${percentageChangeColor} ${percentagesizeStyles[size]} leading-0 font-semibold p-1 rounded flex gap-1 items-center`}
//             >
//               {percentageChange > 0 ? (
//                 <span
//                   className={`material-symbols-outlined ${percentagesizeStyles[size]}`}
//                 >
//                   trending_up
//                 </span>
//               ) : (
//                 <span
//                   className={`material-symbols-outlined ${percentagesizeStyles[size]}`}
//                 >
//                   trending_down
//                 </span>
//               )}
//               <div>{percentageChange.toFixed(2)}%</div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default InfoCardNew;

import React from "react";

const percentagesizeStyles = {
  sm: "!text-[11px]",
  md: "!text-[12px]",
  lg: "!text-[13px]",
  xl: "!text-[14px]",
};
const sizeStyles = {
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const sizeValueStyles = {
  sm: "text-[34px]",
  md: "text-[30px]",
  lg: "text-[38px]",
  xl: "text-[40px]",
};

// Line height mapping for each size to calculate exact height for 2 lines
const lineHeightStyles = {
  sm: 16, // approximately 1.33 * 12px
  md: 18, // approximately 1.29 * 14px
  lg: 20, // approximately 1.25 * 16px
  xl: 22, // approximately 1.22 * 18px
};

const InfoCardNew = ({ title, value, backValue, size = "md" }) => {
  //get percentage change
  //const percentageChange = ((value - backValue) / backValue) * 100;
  const percentageChange =
    backValue === 0 ? null : ((value - backValue) / backValue) * 100;

  // //get percentage change color
  // const percentageChangeColor =
  //   percentageChange > 0
  //     ? "bg-success-500 text-white"
  //     : "bg-danger-500 text-white";

  // // Calculate exact height for 2 lines
  // const exactHeight = lineHeightStyles[size] * 2;

  // Get percentage change color
  const percentageChangeColor =
    percentageChange === null
      ? "bg-gray-500 text-white" // neutral color for N/A
      : percentageChange > 0
      ? "bg-success-50 text-success"
      : "bg-danger-50 text-danger";

  // Calculate exact height for 2 lines
  const exactHeight = lineHeightStyles[size] * 2;

  return (
    // <div className="bg-red">
    //   <div className="p-3 bg-gradient-to-b from-gray-200 to-white rounded-2xl shadow">
    //     <div className=" w-full h-full flex flex-col gap-2">
    //       <div>
    //         <div
    //           className={`${sizeStyles[size]} leading-tight flex items-start`}
    //           style={{
    //             height: `${exactHeight}px`,
    //             overflow: "hidden",
    //             display: "-webkit-box",
    //             WebkitLineClamp: 2,
    //             WebkitBoxOrient: "vertical",
    //             lineHeight: `${lineHeightStyles[size]}px`,
    //           }}
    //         >
    //           {title}
    //         </div>
    //       </div>
    //       <div className="flex-1 gap-2 flex justify-center items-center">
    //         <div className={`${sizeValueStyles[size]} font-semibold`}>
    //           {value}
    //         </div>
    //         <div
    //           className={`${percentageChangeColor} ${percentagesizeStyles[size]} leading-0 font-semibold p-1 rounded flex gap-1 items-center`}
    //         >
    //           {percentageChange > 0 ? (
    //             <span
    //               className={`material-symbols-outlined ${percentagesizeStyles[size]}`}
    //             >
    //               trending_up
    //             </span>
    //           ) : (
    //             <span
    //               className={`material-symbols-outlined ${percentagesizeStyles[size]}`}
    //             >
    //               trending_down
    //             </span>
    //           )}
    //           <div>{percentageChange.toFixed(0)}%</div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="bg-red">
      <div className="p-3 bg-gradient-to-b from-gray-200 to-white rounded-2xl shadow">
        <div className=" w-full h-full flex flex-col gap-2">
          <div>
            <div
              className={`${sizeStyles[size]} leading-tight flex items-start`}
              style={{
                height: `${exactHeight}px`,
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                lineHeight: `${lineHeightStyles[size]}px`,
              }}
            >
              {title}
            </div>
          </div>
          <div className="flex-1 gap-2 flex justify-center items-start">
            <div className={`${sizeValueStyles[size]} font-semibold`}>
              {value}
            </div>
            <div
              className={`${percentageChangeColor} ${percentagesizeStyles[size]} leading-0 font-semibold p-1 rounded flex gap-1 items-center`}
            >
              {percentageChange === null ? (
                <>
                  <span
                    className={`material-symbols-outlined ${percentagesizeStyles[size]}`}
                  >
                    help
                  </span>
                  <div>N/A</div>
                </>
              ) : (
                <>
                  {percentageChange > 0 ? (
                    <span
                      className={`material-symbols-outlined ${percentagesizeStyles[size]}`}
                    >
                      trending_up
                    </span>
                  ) : (
                    <span
                      className={`material-symbols-outlined ${percentagesizeStyles[size]}`}
                    >
                      trending_down
                    </span>
                  )}
                  <div>{percentageChange.toFixed(0)}%</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoCardNew;
